import moment from 'moment'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import { MONTHLY_YEARLY_UPGRADE_PLAN_MAP } from '@/constant/monthlyToYearlyUpgrade'
import Util from '@/util'
import { formatCustomerFacedAmount } from '@/utils/pricing.utils'

const NEW_PRO_PLAN_CONFIG = { DATE: '2025-08-27', LIMIT: 2500 }
const planLimit = (state) => {
  const subscription = state.currentUser?.myPlan?.subscription
  if (!subscription) return state.plan.limit
  if (state.plan?.group === 'pro' && moment(subscription.current_period_start).isAfter(moment(NEW_PRO_PLAN_CONFIG.DATE))) {
    return NEW_PRO_PLAN_CONFIG.LIMIT
  }
  return state.plan.limit
}

const canUseFeaturesByPlanAPI = (_, __, ___, rootGetters) => {
  return isFeatureEnabled(rootGetters, 'release-features-by-plan-api')
}

const eligibleToUpgradeFromMonthlyToYearly = (state) => {
  if (!state.monthlyToYearlyUpgradePreview ||
    !state.monthlyToYearlyUpgradePreview.amountToUpgrade ||
    state.monthlyToYearlyUpgradePreview.amountToUpgrade.amount === null ||
    state.monthlyToYearlyUpgradePreview.amountToUpgrade.amount === undefined
  ) return false
  return !!MONTHLY_YEARLY_UPGRADE_PLAN_MAP[state.currentUser.plan]
}

const monthlyToYearlyUpgradeAmount = (state) => {
  if (!state?.monthlyToYearlyUpgradePreview?.amountToUpgrade) return null
  const { amount, currencySymbol, currency } = state.monthlyToYearlyUpgradePreview.amountToUpgrade
  const monthlyAmount = Math.ceil(amount / 12)
  const customerFacedAmount = formatCustomerFacedAmount(monthlyAmount, currency)
  const formattedAmount = Util.formatNumberWithCommas(customerFacedAmount)
  return `${currencySymbol}${formattedAmount}`
}

const monthlyToYearlyUpgradePromotionCode = (state) => {
  return state.monthlyToYearlyUpgradePreview?.promotionCode
}

const shouldShowMonthlyToYearlyPromo = (state, getters, rootState, rootGetters) => {
  // Check if user has the feature enabled
  const hasFeatureEnabled = rootGetters['featureToggles/canUserOfferingMonthlyToYearly']

  // Check if user is eligible for upgrade
  const isEligible = getters.eligibleToUpgradeFromMonthlyToYearly

  return hasFeatureEnabled &&
    isEligible
}

export default {
  planLimit,
  canUseFeaturesByPlanAPI,
  eligibleToUpgradeFromMonthlyToYearly,
  monthlyToYearlyUpgradeAmount,
  monthlyToYearlyUpgradePromotionCode,
  shouldShowMonthlyToYearlyPromo,
}
